module.exports = __webpack_public_path__ + "static/media/Rosewood Drive, San Francisco, CA2.be70eb7d.jpg";